import { Empty, Spin } from 'antd'
import Control from 'components/Control/Control'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import Label from 'components/Label/Label'
import { FormItem } from 'modules/Onboarding/Register/Education/style'
import {
  Heading,
  SpinWrapper,
} from 'modules/Onboarding/Register/PersonalInfo/style'
import React, { Fragment, useCallback } from 'react'
import { debounce } from '../../../../utils/helpers'
import { RedNote } from './style'

const Address = ({
  form,
  loadingCountry,
  loadingState,
  loadingCity,
  setLoadingCountry,
  setLoadingState,
  setLoadingCity,
  setIsUpdateButtonEnabled,
  countryList,
  stateList,
  cityList,
  onCountryChange,
  onStateChange,
  onCityChange,
  heading,
  address1Name,
  address2Name,
  countryName,
  stateName,
  cityName,
  pincode,
  isTemAddress,
  isSameAddress,
  countryValue,
  stateValue,
  cityValue,
  countryId,
  stateId,
  getStateData,
  getCityData,
  secondAddress1Name,
  secondAddress2Name,
  secondPincode,
  cityId,
  isCorporateMasterExist,
  errorNote,
  setErrorNote,
  getListOfCountries,
  setStateName,
  setStateId,
  setCountryName,
  setCountryId,
  setCityName,
  setCityId,
  handlePinCode,
  frozenFields = {},
}) => {
  const delayStateToDb = useCallback(
    debounce((data1, data2, data3) => {
      form.setFieldsValue({
        [stateName]: '',
        [stateName + 'Id']: '',
      })
      setStateName('')
      setStateId('')
      getStateData(data1, data2, data3)
      setErrorNote(prevError => ({
        ...prevError,
        [stateName]: '',
        [cityName]: '',
      }))
    }, 500),
    []
  )

  const delayCitiesToDb = useCallback(
    debounce((data1, data2, data3, data4) => {
      form.setFieldsValue({
        [cityName]: '',
        [cityName + 'Id']: '',
      })
      setCityId('')
      setCityName('')
      getCityData(data1, data2, data3, data4)
      setErrorNote(prevError => ({
        ...prevError,
        [cityName]: '',
      }))
    }, 500),
    []
  )
  const delayCountryToDb = useCallback(
    debounce(data => {
      form.setFieldsValue({
        [countryName]: '',
        [countryName + 'Id']: '',
      })
      setCountryName('')
      setCountryId('')
      getListOfCountries(data, false)

      setErrorNote(prevError => ({
        ...prevError,
        [countryName]: '',
        [stateName]: '',
        [cityName]: '',
      }))
    }, 500),
    []
  )

  const handleInputChange = e => {
   // setIsUpdateButtonEnabled(false)
  }

  return (
    <Fragment>
      {heading && (
        <Control top="35px">
          <Heading>{heading}</Heading>
        </Control>
      )}
       <Control top="25px" flexStart column>
             <Label>Address line 1 </Label>
             <AntdInput
               placeholder="Enter your address"
               name={address1Name}
               maxLength={120}
               rules={[
                 {
                   min: 3,
                   max: 120,
                   message:
                     'Please enter address 1! Minimum 3 characters , Maximum 120 characters',
                 },
               ]}
               disabled={isTemAddress ? isSameAddress : (frozenFields?.[address1Name] || false)}
               onBlur={e =>
                 isSameAddress &&
                 form.setFieldValue(secondAddress1Name, e.target.value)
               }
               onChange={handleInputChange}
             />
           </Control>
     
           <Control top="25px" flexStart column>
             <Label>Address line 2 </Label>
             <AntdInput
               placeholder="Enter your address"
               name={address2Name}
               maxLength={120}
               rules={[
                 {
                   min: 3,
                   max: 120,
                   message:
                     'Please enter address 2! Minimum 3 characters , Maximum 120 characters',
                 },
               ]}
               disabled={isTemAddress ? isSameAddress : (frozenFields?.[address2Name] || false)}
               onBlur={e =>
                 isSameAddress &&
                 form.setFieldValue(secondAddress2Name, e.target.value)
               }
               onChange={handleInputChange}
             />
           </Control>

      <Control top="25px" flexStart gap="15px">
        <Control flexStart column>
          <Label>Country *</Label>
          <FormItem name={countryName}>
            <div></div>
          </FormItem>
          <AntdSelect
            placeholder="Select"
            name={countryName + 'Id'}
            filterOption={false}
            rules={[
              {
                required: true,
                message: 'Please select country!',
              },
              {
                validator: async (_, value) => {
                  if (value) {
                    let masterList = await isCorporateMasterExist(
                      value,
                      countryName
                    )

                    if (masterList) {
                      return Promise.reject(new Error('Please select country!'))
                    } else {
                      return Promise.resolve()
                    }
                  }
                  return Promise.resolve()
                },
              },
            ]}
            OptionData={loadingCountry ? [] : countryList}
            notFoundContent={
              loadingCountry ? (
                <SpinWrapper center>
                  <Spin />
                </SpinWrapper>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
            valueParam="name"
            nameParam="name"
            onChange={onCountryChange}
            value={countryValue}
            showSearch={true}
            disabled={isTemAddress ? (isSameAddress || frozenFields?.[countryName] || frozenFields?.[countryName + 'Id'] || false) : (frozenFields?.[countryName] || frozenFields?.[countryName + 'Id'] || false)}
            onSearch={data => {
              setLoadingCountry(true);
              delayCountryToDb(data);
            }}
          />
          {errorNote?.[countryName] && (
            <RedNote>{errorNote?.[countryName]}</RedNote>
          )}
        </Control>
        <Control flexStart column>
          <Label>State *</Label>
          <FormItem name={stateName}>
            <div></div>
          </FormItem>
          <AntdSelect
            showSearch={true}
            filterOption={false}
            placeholder="Select"
            name={stateName + 'Id'}
            rules={[
              {
                required: true,
                message: 'Please select state!',
              },
              {
                validator: async (_, value) => {
                  if (value) {
                    try {
                      let masterList = await isCorporateMasterExist(
                        value,
                        stateName
                      )

                      if (masterList) {
                        return Promise.reject(new Error('Please select state!'))
                      } else {
                        return Promise.resolve()
                      }
                    } catch (error) {
                      console.error('Error validating state:', error)
                      return Promise.resolve()
                    }
                  }
                  return Promise.resolve()
                },
              },
            ]}
            OptionData={loadingState ? [] : stateList}
            notFoundContent={
              loadingState ? (
                <SpinWrapper center>
                  <Spin />
                </SpinWrapper>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
            valueParam="name"
            nameParam="name"
            onChange={onStateChange}
            value={stateValue}
            disabled={
              isTemAddress
                ? isSameAddress && form.getFieldValue(countryName)
                  ? true
                  : !form.getFieldValue(countryName)
                : frozenFields?.[stateName] || (!form.getFieldValue(countryName))
            }
            onSearch={data => {
              setLoadingState(true);
                delayStateToDb(countryId, !isTemAddress, data);
            }}
          />
          {errorNote?.[stateName] && (
            <RedNote>{errorNote?.[stateName]}</RedNote>
          )}
        </Control>
      </Control>

      <Control top="25px" flexStart gap="15px">
        <Control flexStart column>
          <Label>City *</Label>
          <FormItem name={cityName}>
            <div></div>
          </FormItem>
          <AntdSelect
            placeholder="Select"
            name={cityName + 'Id'}
            filterOption={false}
            rules={[
              {
                required: true,
                message: 'Please select city!',
              },

              {
                validator: async (_, value) => {
                  if (value) {
                    let masterList = await isCorporateMasterExist(
                      value,
                      cityName
                    )

                    if (masterList) {
                      return Promise.reject(new Error('Please select city!'))
                    } else {
                      return Promise.resolve()
                    }
                  }
                  return Promise.resolve()
                },
              },
            ]}
            OptionData={loadingCity ? [] : cityList}
            notFoundContent={
              loadingCity ? (
                <SpinWrapper center>
                  <Spin />
                </SpinWrapper>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )
            }
            valueParam="name"
            nameParam="name"
            onChange={onCityChange}
            value={cityValue}
            showSearch={true}
            disabled={
              isTemAddress
                ? isSameAddress
                  ? true
                  : !form.getFieldValue(stateName + 'Id') ||
                    !form.getFieldValue(countryName + 'Id')
                : frozenFields?.[cityName] || (!form.getFieldValue(stateName + 'Id') ||
                  !form.getFieldValue(countryName + 'Id'))
            }
            onSearch={data => {
              setLoadingCity(true);
                delayCitiesToDb(countryId, stateId, !isTemAddress, data);
            }}
          />
          {errorNote?.[cityName] && <RedNote>{errorNote?.[cityName]}</RedNote>}
        </Control>

        <Control flexStart column>
          <Label>Pincode *</Label>
          <AntdInput
            id={pincode}
            placeholder="121212"
            name={isSameAddress ? 'permPostCode' : pincode}
            rules={[
              {
                validator: (_, value) => {
                  if (!value || (value >= 100000 && value <= 999999)) {
                    return Promise.resolve()
                  } else {
                    return Promise.reject(new Error('Please Enter Valid Pincode'))
                  }
                },
              },
            ]}
            disabled={isTemAddress ? isSameAddress : (frozenFields?.[pincode] && form.getFieldValue(isSameAddress ? 'permPostCode' : pincode) ? true : false)}
            value={form.getFieldValue(isSameAddress ? 'permPostCode' : pincode) || ''}
            onChange={e => {
              handlePinCode(e)

              handleInputChange(e)
            }}
          />
        </Control>
      </Control>
    </Fragment>
  )
}

export default Address
